// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_3j2rZ","icon":"index_icon_3SKag"};